import { Category } from '../types';

/**
 * Builds the full category path from root to the given category
 * @param category - The target category
 * @param allCategories - All categories to search through
 * @returns Array of categories from root to target
 */
export const buildCategoryPath = (category: Category, allCategories: Category[]): Category[] => {
  const path: Category[] = [category];
  let currentCategory = category;

  while (currentCategory.parent_id) {
    const parent = allCategories.find(cat => cat.id === currentCategory.parent_id);
    if (parent) {
      path.unshift(parent);
      currentCategory = parent;
    } else {
      break;
    }
  }

  return path;
};

/**
 * Formats category path as a string with separators
 * @param category - The target category
 * @param allCategories - All categories to search through
 * @param separator - Separator between categories (default: ' > ')
 * @returns Formatted path string
 */
export const getCategoryPathString = (
  category: Category, 
  allCategories: Category[], 
  separator: string = ' > '
): string => {
  const path = buildCategoryPath(category, allCategories);
  return path.map(cat => cat.title).join(separator);
};

/**
 * Formats a number as Persian currency
 * @param amount - The amount to format
 * @returns Formatted currency string
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('fa-IR').format(amount) + ' تومان';
};

/**
 * Formats a date in Persian format
 * @param dateString - ISO date string
 * @returns Formatted Persian date
 */
export const formatPersianDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('fa-IR');
}; 